import linkRequestFragment from './linkRequest.fragment.js'

const searchResponseFacetsFragment = /* GraphQL */ `
  fragment searchResponseFacetsFragment on SearchResponseFacet {
    facetName
    hasShowMore
    isForFacetResultPage
    isForTopCategories
    shouldUseImageUrlForTopCategories
    showTopCategoryTitle
    isForSearchFacetResultPage
    isMultiSelect
    isSelected
    lazyLoaded
    isCriticalAttribute
    facetType
    displayPosition
    searchResponseFacetOptions {
      orderedSortIndex
      relevanceSortIndex
      thumbnailImageUrl
      displayValue
      resultCount
      isSuggestedFacet
      suggestionSortIndex
      isSelected
      excludeFromTopCategories
      parentFacetIdentifiers
      id
      displayPosition
      facetOptionLink {
        url
        noFollow
      }
      engineFitmentFacetOptionDetails {
        engineVersionId
        engineQualifierId
        engineDisplacementId
        engineCodeId
        engineCamshaftTypeId
        engineFuelSystemId
      }
      ...linkRequestFragment
    }
  }

  ${linkRequestFragment}
`

export default searchResponseFacetsFragment
